var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconFileDoneGreen = function SvgIconFileDoneGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.333 25.333H6.667V12a2.667 2.667 0 0 1 2.666-2.667h14.813a2.667 2.667 0 0 1 1.98.884l7.607 8.45h20.934a2.667 2.667 0 0 1 2.666 2.666v4Z",
    fill: "#239A6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.333 17.333H14.666c-.736 0-1.333.597-1.333 1.334v24c0 .736.597 1.333 1.333 1.333h34.667c.736 0 1.333-.597 1.333-1.333v-24c0-.737-.597-1.334-1.333-1.334Z",
    fill: "#CFFCEC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.666 22.667H9.334a2.667 2.667 0 0 0-2.667 2.666V52a2.667 2.667 0 0 0 2.667 2.667h45.334A2.667 2.667 0 0 0 57.332 52V25.333a2.667 2.667 0 0 0-2.666-2.666Z",
    fill: "#15C480"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.333 62.667c6.812 0 12.334-5.522 12.334-12.334C62.667 43.522 57.145 38 50.333 38 43.522 38 38 43.522 38 50.333c0 6.812 5.522 12.334 12.333 12.334Z",
    fill: "#FFC82A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m50.77 54.933 5.904-6.792a1.833 1.833 0 1 0-2.768-2.406l-5.904 6.793a1.833 1.833 0 0 0 2.767 2.405Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m50.68 52.433-4.007-4.007a1.833 1.833 0 0 0-2.593 2.593l4.007 4.007a1.834 1.834 0 0 0 2.593-2.593Z",
    fill: "#fff"
  })));
};
export default SvgIconFileDoneGreen;